// Staff dashboard route (inside BodyView layout)
export default [
  {
    path: '/staff-dashboard',
    name: 'StaffDashboard',
    component: () => import("@/views/Page/Staff/StaffDashboard.vue"),
    meta: {
      title: 'Staff Dashboard',
      requiresStaffAuth: true,
    },
  },
  {
    path: '/staff/absence-requests',
    name: 'StaffAbsenceRequests',
    component: () => import("@/views/Page/Staff/StaffAbsenceRequests.vue"),
    meta: {
      title: 'Absence Requests',
      requiresStaffAuth: true,
    },
  },
  {
    path: '/staff/withdrawal-requests',
    name: 'StaffWithdrawalRequests',
    component: () => import("@/views/Page/Staff/StaffWithdrawalRequests.vue"),
    meta: {
      title: 'Withdrawal Requests',
      requiresStaffAuth: true,
    },
  },
  {
    path: '/staff-students',
    name: 'StaffStudents',
    component: () => import("@/views/Page/Staff/StaffStudents.vue"),
    meta: {
      title: 'My Students',
      requiresStaffAuth: true,
    },
  },
  {
    path: '/staff-section-marks',
    name: 'StaffSectionMarks',
    component: () => import("@/views/Page/Staff/StaffSectionMarks.vue"),
    meta: {
      title: 'Section Marks',
      requiresStaffAuth: true,
    },
  },
];

